import {LastReplacementDatePicker} from '../components/LastReplacementDatePicker';
import {LastReplacementMileageInput} from '../components/LastReplacementMileageInput';
import {NextReplacementDatePicker} from '../components/NextReplacementDatePicker';
import {NextReplacementMileageInput} from '../components/NextReplacementMileageInput';
import {ReplacementAfterMileageInput} from '../components/ReplacementAfterMileageInput';
import {ReplacementAfterMonthsInput} from '../components/ReplacementAfterMonthsInput';

export function EngineOilReplacementGroup() {
  return (
    <>
      <LastReplacementDatePicker name="engineOil" />
      <LastReplacementMileageInput name="engineOil" />
      <NextReplacementDatePicker name="engineOil" />
      <NextReplacementMileageInput name="engineOil" />
      <ReplacementAfterMonthsInput name="engineOil" />
      <ReplacementAfterMileageInput name="engineOil" />
    </>
  );
}
